// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__nyQZ3","options":"AnswerScale_options__2HNJu","selected":"AnswerScale_selected__GbaSR"};